import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import Picture from '../../Picture'

class HomepageHeadhunt extends Component
{
    container = React.createRef()
    parallax = React.createRef()

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll)
        this.onScroll()
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
    }

    onScroll = (e) => {
        const scrollY = window.scrollY
        const delta = scrollY / this.container.current.offsetHeight
        this.parallax.current.style.marginTop = Math.round(60 * delta - 300) + 'px'
    }

    render() {
        return (
            <section className="section-default section-headhunt" ref={this.container}>
                <div className="section-default-after section-headhunt-after" ref={this.parallax}/>
                <div className="container">
                    <div className="default-wrap headhunt-wrap">
                        <div className="headhunt-img" />
                        <div className="default-text headhunt-text">
                            <h2>
                                <FormattedMessage
                                    id="portfolio.homepage.headhunt.title"
                                    defaultMessage="Un cabinet de recrutement avec des chasseurs de têtes spécialisés."
                                />
                            </h2>
                            <p className="default-text-subtitle headhunt-text-subtitle">
                                <FormattedMessage
                                    id="portfolio.homepage.headhunt.subtitle"
                                    defaultMessage="Urban Linker est un cabinet de recrutement innovant et expert des métiers du digital et de la tech, proposant un service dédié aux acteurs du Web et de l’écosystème start-up français."
                                />
                            </p>
                            <p className="default-text-paragraph headhunt-text-paragraph">
                                <FormattedMessage
                                    id="portfolio.homepage.headhunt.paragraph_1"
                                    defaultMessage="Notre équipe de chasseurs de têtes est spécialisée dans le recrutement de profils numériques"
                                />
                            </p>
                            <p className="default-text-paragraph headhunt-text-paragraph">
                                <FormattedMessage
                                    id="portfolio.homepage.headhunt.paragraph_2"
                                    defaultMessage="Candidats et recruteurs, nous comprenons parfaitement vos besoins et vos problématiques en matière de recrutement."
                                />
                            </p>
                            <p className="default-text-paragraph headhunt-text-paragraph">
                                <FormattedMessage
                                    id="portfolio.homepage.headhunt.paragraph_3"
                                    defaultMessage="Présents à Paris, Lyon et Bordeaux, nous accompagnons des entreprises partout en France et en Europe."
                                />
                            </p>

                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default HomepageHeadhunt;
